import { useCallback, useState } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import PricingSection from "@/components/PricingSection";
import FeatureMatrix from "@/components/FeatureMatrix";
import Footer from "@/components/Footer";
import EnterpriseModal from "@/components/EnterpriseModal";

export default function Home() {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = useCallback(() => setModalOpen(true), []);

  return (
    <div className="bg-[#0F1E3D] min-h-screen" data-testid="atlantis-home">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <PricingSection onEnterprise={openModal} />
        <FeatureMatrix />
        <Footer />
      </main>
      <EnterpriseModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
}